var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.941 511.941",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.971 0c-33.091 0-60 26.909-60 60s26.909 61 60 61 60-27.909 60-61-26.909-60-60-60zM450.971 60c0-33.091-26.909-60-60-60s-60 26.909-60 60 26.909 61 60 61 60-27.909 60-61zM175.166 455.08c34.915 29.297 43.51 37.55 52.855 45.495 8.906 7.573 20.024 11.367 31.143 11.367 11.221 0 22.441-3.867 31.348-11.572 16.271-14.086 33.904-30.339 49.763-44.242-8.513-2.86-16.531-7.425-23.22-14.121-17.811-17.789-22.758-44.738-11.499-68.324-30.586-16.192-68.529-16.15-99.131.068 11.204 23.558 6.266 50.475-11.552 68.271a59.463 59.463 0 0 1-19.707 13.058z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.971,
    cy: 271,
    r: 30,
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.971 192.25c-20.537-37.002-55.986-69.038-106.26-69.038-69.141 0-121.274 56.045-121.274 130.356 0 65.643 44.645 113.774 115.203 174.664 10.386 3.122 22.026.551 30.037-7.438 12.292-12.261 11.296-32.223-1.216-43.594-64.395-58.506-84.023-85.735-84.023-116.233h30c0 18.898 18.433 42.793 69.009 89.208 41.719-24.481 95.347-24.428 137.051.002 50.574-46.415 69.009-70.312 69.009-89.21h30c0 30.498-19.629 57.727-84.023 116.233-12.442 11.309-13.566 31.274-1.23 43.579 10.115 10.087 25.86 11.224 37.712 3.517 75.026-68.353 107.542-110.757 107.542-170.729 0-74.312-52.134-130.356-121.274-130.356-50.292.001-85.726 32.037-106.263 69.039zm60 78.75c0 33.091-26.909 60-60 60s-60-26.909-60-60 26.909-60 60-60 60 26.909 60 60z",
    fill: "#107988",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParent);
export default __webpack_public_path__ + "static/media/parent.942238db05c611e915d91b959da61176.svg";
export { ForwardRef as ReactComponent };